import api from 'api'
import { VoohCreation, VoohUsedMedia } from '../VoohCampaignForm/types'
import { store } from '../../../store'
import { voohCreationEmissionActions } from './slice'
import { VoohCreationEmissionSliceEmpty } from './types'
import { CreationSchedule } from '../../../types/campaign'
import { DateRange } from '../../../components/Form/DatePickerRange'
import DateUtils from '../../../utils/date'
import { DATE_FORMAT } from '../../../constant'
import VariableUtils from '../../../utils/variable'

export default class Service {
  static getVoohCreationEmissionData = (voohCreationId: VoohCreation['id']): void => {
    const query = api.voohCreation.getVoohCreation(voohCreationId)
    query.then(res => {
      store.dispatch(
        voohCreationEmissionActions.createVoohCreationEmission({
          creationId: res.data.node.id,
          details: res.data.node.details,
          duration: res.data.node.duration,
          mediaFormat: res.data.node.mediaFormat,
          campaign: res.data.node.campaign || VoohCreationEmissionSliceEmpty.campaign,
          schedules:
            res.data.node.schedules.map(el => {
              return {
                startDate: el.startDate as any,
                endDate: el.endDate as any,
              }
            }) || [],
          hourFrequency: res.data.node.hourFrequency,
          mediums: res.data.node.mediaTree || [],
          selectedMediums: res.data.node.media || [],
          file: {
            name: res.data.node.file?.filename || '',
            url: res.data.node.file?.url || '',
          },
          thumbnailUrl: res.data.node.thumbnailUrl || '',
        })
      )
    })
  }

  static creationSchedulesToDateRanges = (
    creationSchedules: CreationSchedule<string>[]
  ): DateRange[] => {
    return creationSchedules.map((creationSchedule: CreationSchedule<string>) => {
      const from = new Date(creationSchedule.startDate)
      const to = new Date(creationSchedule.endDate)

      return { from, to }
    })
  }

  static parseSchedule = (creationSchedule: CreationSchedule<string>): string => {
    const fromDate = new Date(creationSchedule.startDate)
    const toDate = new Date(creationSchedule.endDate)

    const from = DateUtils.parseAndFormat(fromDate, DATE_FORMAT)
    const to = DateUtils.parseAndFormat(toDate, DATE_FORMAT)
    const isSingleDay = from === to

    return `${from}${isSingleDay ? '' : ' - ' + to}`
  }

  static dateRangesToCreationSchedules = (dateRanges: DateRange[]): CreationSchedule[] => {
    return dateRanges.map((dateRange: DateRange) => ({
      startDate: dateRange.from!,
      endDate: dateRange.to!,
    }))
  }

  static handleChangeVoohCreationSchedules = (
    dateRanges: DateRange[],
    creationId: VoohCreation['id'],
    currentCreationSchedules: CreationSchedule<string>[]
  ): void => {
    const creationScheduleDateRanges =
      Service.creationSchedulesToDateRanges(currentCreationSchedules)

    const creationSchedulesHaveChanged = !VariableUtils.isDeepEqual(
      creationScheduleDateRanges,
      dateRanges
    )

    if (!creationSchedulesHaveChanged) {
      return
    }

    const creationSchedulesFromDatePicker = Service.dateRangesToCreationSchedules(dateRanges)

    void Service.updateVoohCreationSchedules(creationId, creationSchedulesFromDatePicker)
  }

  static updateVoohCreationSchedules = (
    creationId: VoohCreation['id'],
    creationSchedules: CreationSchedule[]
  ): Promise<void> => {
    store.dispatch(voohCreationEmissionActions.setLoading({ key: 'schedules', value: true }))
    return api.voohCreation
      .updateVoohCreationSchedule(creationId, creationSchedules)
      .then(res => {
        const success = res.data?.updateVoohCreationSchedules.success
        if (success) {
          const mappedCreationSchedules: CreationSchedule<string>[] = creationSchedules.map(
            (creationSchedule: CreationSchedule) => ({
              startDate: creationSchedule.startDate.toISOString(),
              endDate: creationSchedule.endDate.toISOString(),
            })
          )

          store.dispatch(
            voohCreationEmissionActions.setVoohCreationSchedules(mappedCreationSchedules)
          )
        }
      })
      .catch(() => void {})
      .finally(() => {
        store.dispatch(voohCreationEmissionActions.setLoading({ key: 'schedules', value: false }))
      })
  }

  static updateVoohCreationMedia = (
    creationId: VoohCreation['id'],
    media: VoohUsedMedia[]
  ): Promise<void> => {
    store.dispatch(voohCreationEmissionActions.setLoading({ key: 'locations', value: true }))
    return api.voohCreation
      .updateVoohCreationMedia(creationId, media)
      .then(res => {
        const success = res.data?.updateVoohCreationMedia.success
        if (success) {
          store.dispatch(voohCreationEmissionActions.setLoading({ key: 'locations', value: false }))
        }
      })
      .catch(() => {
        store.dispatch(voohCreationEmissionActions.setLoading({ key: 'locations', value: false }))
      })
  }
}
